import { MAX_URL_LENGTH } from '../../../utils';
export default {
    name: 'UrlEditor',
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            value$: this.value,
            MAX_URL_LENGTH,
        };
    },
    watch: {
        value: {
            immediate: true,
            handler() {
                this.value$ = this.value;
            },
        },
    },
    mounted() {
        this.$nextTick(() => {
            if (this.$refs.inputRef) {
                this.$refs.inputRef.focus();
            }
        });
    },
    methods: {
        onEnter() {
            if (this.$refs.inputRef) {
                this.$refs.inputRef.blur();
            }
        },
        onFinishEdit() {
            this.$emit('endLabelingField');
            this.$emit('updateFieldValue', this.value$);
        },
    },
};
